import { Component, inject, OnInit } from '@angular/core';
import { AnnouncementsService } from '../../services/announcements.service';
import { Announcement } from '../../models/announcement.model';
import { RouterLink } from '@angular/router';
import { ToastService } from '../../services/toast.service';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from '../../components/pagination/pagination.component';

@Component({
  selector: 'app-announcements',
  imports: [RouterLink, DatePipe, FormsModule, PaginationComponent],
  templateUrl: './announcements.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class AnnouncementsComponent implements OnInit {
  announcements: Announcement[] | null = [];
  loading = true;
  params = {
    title: '',
    start_date: '',
    page: 1,
    order: '',
    limit: 6,
    is_active: true
  };
  timeout: any;
  total = 0;

  private announcementsService = inject(AnnouncementsService);
  private toast = inject(ToastService);

  ngOnInit() {
    this.getAnnouncements();
  }

  getAnnouncements() {
    this.loading = true;
    this.announcements = [];

    this.announcementsService.getAll(this.params).subscribe({
      next: (res) => {
        this.loading = false;
        this.announcements = res.data.records;
        this.total = res.data.total_record;
      },
      error: () => {
        this.loading = false;
        this.toast.error('Error al obtener datos');
      }
    });
  }

  handleSearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.search(), 600);
  }

  search() {
    this.params.page = 1;
    this.getAnnouncements();
  }
}
